
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    type: { type: String, default: "default" },
  },
  computed: {
    className(): string {
      return `icon-button ${this.type}`;
    },
  },
});
